import React, { useContext, useEffect, useState } from 'react'
import styles from "../../Styles/ComponentStyles/MainPages/Profile.module.scss"
import globalStyles from "../../Styles/global.module.scss"
import memberUserStyles from "../../Styles/ComponentStyles/MainPages/Member.module.scss"

import AddIcon from '@mui/icons-material/Add'

import Grid from '@mui/material/Grid2';
import { Avatar, Box, IconButton, Tooltip, Typography } from '@mui/material';
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { DataGrid } from '@mui/x-data-grid';

import deleteIcon from "../../Assets/Member/Delete-Icons.svg"
import GlobalDialog from '../../Utils/Layout/GlobalDialog/GlobalDialog';
import ProfileNewMemberDialog from './ProfileDialogs/ProfileNewMemberDialog';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import agent from '../../Services/api';
import GlobalWarningDialog from '../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import useStateOptions from '../../Utils/Hooks/useStateOptions';
import { capitalize } from '../../Utils/Constant/Constant'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';


const ProfileAcrylicTeam = () => {

    const {
        userProfileDetails,
        profileTeamDetails,
        setFlagLoader,
        setProfileTeamDetails,
        setUserProfileDetails
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const isProfileAdmin = userProfileDetails?.user?.flagAdmin
    const { showSnackbar } = useSnackbar();

    const { userDetails, setUserDetails } = useContext(DashboardContext) as DashboardDetailPayload
    const [dialogTitleName, setDialogTitleName] = useState("New Member");

    const [flagOpenNewMemberDialog, setFlagOpenNewMemberDialog] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState<any | "">("");
    const [profileMemberPayloadDetails, setProfileMemberPayloadDetails] = useState<any>(null)
    const [storedExistingMemberDetails, setStoredExistingMemberDetails] = useState<{
        fullName: string;
        teamId: number;
    } | null>(null);
    const [flagDeleteTeamMemberDialog, setFlagDeleteTeamMemberDialog] = useState<any>(false);



    useEffect(() => {
        getUserDetails()
        initializeAcrylicTeamListAuth()
    }, [])

    useEffect(() => {
        if (flagOpenNewMemberDialog) {
            if (profileMemberPayloadDetails?.teamId) {
                const fName = profileMemberPayloadDetails?.firstName || "";
                const lName = profileMemberPayloadDetails?.lastName || "";
                setDialogTitleName(`${capitalize(fName)} ${capitalize(lName)}`);
            } else {
                setDialogTitleName("New Member");
            }
        }
    }, [flagOpenNewMemberDialog]);

    const getUserDetails = async () => {
        try {
            setFlagLoader(true)
            const response = await agent.getUserProfileDetailsAPI.get()
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setUserProfileDetails({
                    ...userProfileDetails,
                    user: {
                        ...userProfileDetails.user,
                        profileImage: response?.data?.user?.profileImage
                    }
                });
                setFlagLoader(false)
            } else {
                const err = response?.error?.message ? response?.error?.message : "Error fetching user details 1";
                showSnackbar(err, 'error')
                setFlagLoader(false)
            }
        } catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }




    const adminReorderColumn = {
        field: '',
        headerName: '',
        flex: 1,
        width: 90,
        minWidth: 90,
        maxWidth: 90,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params: any) => {
            const isDefault = params?.row?.isDefault;
            if (!isDefault) return null;

            const defaultItems = profileTeamDetails.filter((item: any) => item.isDefault);
            const currentIndex = defaultItems.findIndex((item: any) => item.teamId == params.row.teamId);
            const isFirstDefault = currentIndex == 0;
            const isLastDefault = currentIndex == defaultItems.length - 1;

            return (
                <Grid size={{ xs: 12 }} onClick={(e) => { e.stopPropagation(); }}>
                    <Grid container sx={{ gap: "3px", justifyContent: 'center' }}>
                        {!isFirstDefault && (
                            <Tooltip
                                title="Move Up"
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: { backgroundColor: '#0087FF', fontSize: '10px', maxWidth: 300 }
                                    },
                                    arrow: { sx: { color: '#0087FF' } }
                                }}
                            >
                                <IconButton
                                    className={memberUserStyles.iconHovering}
                                    onClick={(e) => { e.stopPropagation(); moveRow("up", params.row.teamId); }}
                                >
                                    <PlayArrowIcon
                                        className={memberUserStyles.upArrow}
                                        sx={{ fontSize: "23px", color: "white" }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        {!isLastDefault && (
                            <Tooltip
                                title="Move Down"
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: { backgroundColor: '#0087FF', fontSize: '10px', maxWidth: 300 }
                                    },
                                    arrow: { sx: { color: '#0087FF' } }
                                }}
                            >
                                <IconButton
                                    className={memberUserStyles.iconHovering}
                                    onClick={(e) => { e.stopPropagation(); moveRow("down", params.row.teamId); }}
                                >
                                    <PlayArrowIcon
                                        className={memberUserStyles.downArrow}
                                        sx={{ fontSize: "23px", color: "white" }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Grid>
                </Grid>
            );
        }
    };
    const baseColumns: any = [
        {
            field: 'image',
            headerName: 'IMAGE',
            flex: 1,
            width: 80,
            minWidth: 80,
            maxWidth: 80,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const image = params.row.image ? params.row.image : "";
                return (
                    <Avatar
                        src={image}
                        sx={{ width: 30, height: 30 }}
                    />
                )
            }
        },
        {
            field: 'firstName',
            headerName: 'FULL NAME',
            minWidth: 280,
            maxWidth: 320,
            flex: 1,
            valueGetter: (params: any) => {
                const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                const firstName = capitalize(params.row?.firstName || '');
                const lastName = capitalize(params.row?.lastName || '');
                return `${firstName} ${lastName}`?.trim();
            },
            renderCell: (params: any) => {
                const capitalize = (str: string) =>
                    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

                const firstName = capitalize(params.row?.firstName || '');
                const lastName = capitalize(params.row?.lastName || '');
                const fullName = `${firstName} ${lastName}`.trim();

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span>{fullName}</span>
                        {params.row.isDefault && (
                            <span
                                style={{
                                    fontSize: '12px',
                                    padding: '2px 8px',
                                    border: '1px solid #7ED957',
                                    borderRadius: '12px',
                                    color: '#7ED957',
                                    fontWeight: 500,
                                    backgroundColor: '#1F2A37',
                                }}
                            >
                                Default
                            </span>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'memberTitle',
            headerName: 'TITLE',
            flex: 1,
            minWidth: 150,
            maxWidth: 220,
        },
        {
            field: 'memberEmail',
            headerName: 'EMAIL',
            flex: 1,
            minWidth: 320,
            maxWidth: 350,
        },
        {
            field: 'memberPhone',
            headerName: 'PHONE',
            flex: 1,
            minWidth: 200,
            maxWidth: 200
        },
        {
            field: 'description',
            headerName: 'DESCRIPTION',
            flex: 1,
            width: 300,
            minWidth: 300,
        },
        {
            field: 'action',
            headerName: '',
            minWidth: 50,
            maxWidth: 50,
            width: 50,
            align: "right",
            headerAlign: "right",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const isDefault = params.row.isDefault;
                const isAdmin = isProfileAdmin;

                // If not admin and this row is default, don't render delete button at all
                if (!isAdmin && isDefault) return null;
                return (
                    <>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                setStoredExistingMemberDetails({
                                    teamId: params.row.teamId,
                                    fullName: `${params.row.firstName} ${params.row.lastName}`
                                });
                                setFlagDeleteTeamMemberDialog(true);
                            }}
                        >
                            <Tooltip
                                title="Delete"
                                arrow
                                placement="bottom"
                                componentsProps={{
                                    tooltip: { className: globalStyles.globalTooltipStyle },
                                    arrow: { className: globalStyles.globalTooltipArrowStyle },
                                }}
                            >
                                <img src={deleteIcon} alt="" style={{ width: '30px', height: '30px' }} />
                            </Tooltip>
                        </IconButton>
                    </>
                )
            }

        }
    ];
    const columns = isProfileAdmin ? [adminReorderColumn, ...baseColumns] : baseColumns;


    const moveRow = async (direction: "up" | "down", teamId: number) => {
        // Create a copy of the current list
        const listCopy = [...profileTeamDetails];

        // Find the item to move
        const itemIndex = listCopy?.findIndex((row) => row.teamId == teamId && row.isDefault);
        if (itemIndex === -1) return;

        // Calculate target index
        const targetIndex = direction === "up" ? itemIndex - 1 : itemIndex + 1;

        // Find the bounds for default items only
        const defaultItems = listCopy?.filter(item => item.isDefault);
        const defaultItemIndex = defaultItems?.findIndex(item => item.teamId == teamId);
        const targetDefaultIndex = direction == "up" ? defaultItemIndex - 1 : defaultItemIndex + 1;

        // Check bounds within default items
        if (targetDefaultIndex < 0 || targetDefaultIndex >= defaultItems.length) return;

        // Find the target item in the full list
        const targetItem = listCopy?.find(item => item.teamId == defaultItems[targetDefaultIndex].teamId);
        const targetItemIndex = listCopy?.findIndex(item => item.teamId == defaultItems[targetDefaultIndex].teamId);

        if (targetItemIndex === -1) return;

        // Swap the items in the full list
        [listCopy[itemIndex], listCopy[targetItemIndex]] = [listCopy[targetItemIndex], listCopy[itemIndex]];

        // Update sequence numbers for default items only
        let sequence = 1;
        const updatedList = listCopy?.map((item) => {
            if (item.isDefault) {
                return {
                    ...item,
                    sequenceNumber: sequence++
                };
            }
            return item;
        });

        setProfileTeamDetails(updatedList);
        try {
            const response = await handleTeamOrdering(updatedList);
            if (!response?.status) {
                // If API fails, revert to original state
                setProfileTeamDetails(profileTeamDetails);
                showSnackbar("Unable to reorder team. Please try again.", "error");
            }
        }
        catch (error) {
            // If API fails, revert to original state
            setProfileTeamDetails(profileTeamDetails);
            showSnackbar("Unable to reorder team. Please try again.", "error");
        }
    };

    const handleTeamOrdering = async (teamList: any[]) => {
        try {
            const payload = teamList?.filter((item) => item.isDefault)?.map((item) => ({
                acrylicTeamId: Number(item.teamId),
                sequenceNumber: item.sequenceNumber,
            }));

            const response = await agent.updateAcrylicTeamOrderApi.put(payload);
            return response;
        } catch (error) {
            console.error("Ordering failed", error);
            return { status: false };
        }
    };

    const NoDataOverlay = () => (
        <Box
            sx={{
                textAlign: 'center',
                width: '100%',
                color: '#ccc',
                height: '100%',
            }}
        >
            <div style={{ fontWeight: 500, height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                No Data Found
            </div>
        </Box>
    );

    const initializeAcrylicTeamListAuth = async (userId: number | null = null) => {

        let payloadQuery = "";
        if (isProfileAdmin) {
            // Admin: always pass flagGetAll=false and userId
            payloadQuery = `flagGetAll=false&assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        } else {
            // Non-admin: pass only assignedToUserId
            payloadQuery = `assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        }

        setFlagLoader(true);
        const response = await agent.getAcrylicTeamMemberDashboardApi.get(payloadQuery);
        console.log("response of getAcrylicTeamMemberApi", response);
        if (response?.status && response?.data) {
            const originalList = response?.data;
            let sequence = 1;
            const enrichedList = originalList?.map((item: any) => {
                if (item.isDefault) {
                    return { ...item, sequenceNumber: sequence++ };
                }
                return { ...item, sequenceNumber: null };
            });
            setProfileTeamDetails(enrichedList);
            setFlagLoader(false);
        }
        else {
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    };

    const handleClose = (event: any, reason: any) => {
        if (reason && reason == "backdropClick") {
            return;
        }
        setFlagOpenNewMemberDialog(false)
    }

    const handleDeleteMember = async () => {
        if (!storedExistingMemberDetails?.teamId) return;

        setFlagLoader(true);

        let payload = {
            acrylicTeamId: storedExistingMemberDetails.teamId
        }

        const response = await agent.deleteAcrylicTeamApi.delete(payload);
        if (response?.status) {
            const successmessage = response?.message || 'Acrylic team deleted successfully!';
            showSnackbar(successmessage, 'success');
            const passUserId = selectedUserId ? selectedUserId : null
            initializeAcrylicTeamListAuth(passUserId);
            setFlagLoader(false);
        }
        else {
            const errorMessage = response?.data?.error?.message || "Something went wrong!";
            showSnackbar(errorMessage, "error");
            setFlagLoader(false);
        }
        setFlagDeleteTeamMemberDialog(false);
        setStoredExistingMemberDetails(null);
    };

    return (
        <>

            {flagOpenNewMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead={dialogTitleName}
                    open={flagOpenNewMemberDialog}
                    view={
                        <ProfileNewMemberDialog
                            flagOpenNewMemberDialog={flagOpenNewMemberDialog}
                            setFlagOpenNewMemberDialog={setFlagOpenNewMemberDialog}

                            profileMemberPayloadDetails={profileMemberPayloadDetails}
                            setProfileMemberPayloadDetails={setProfileMemberPayloadDetails}

                            selectedUserId={selectedUserId}
                            initializeAcrylicTeamListAuth={initializeAcrylicTeamListAuth}

                            isEditMode={!!profileMemberPayloadDetails?.teamId}
                        />
                    }
                    onClose={handleClose}
                />
            }


            {flagDeleteTeamMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteTeamMemberDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => setFlagDeleteTeamMemberDialog(false)}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want to delete ${storedExistingMemberDetails?.fullName}?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteMember}
                            handleClose={() => setFlagDeleteTeamMemberDialog(false)}
                        />
                    }
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }} className={`${styles.profileWrapperItem}`} sx={{ margin: "15px 0px" }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ mb: "15px", textAlign: 'end' }}>
                            <GlobalButton
                                value='Add Member'
                                size='medium'
                                className={memberUserStyles.atCloseBtnStyle}
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    setFlagOpenNewMemberDialog(true)
                                    setSelectedUserId(userProfileDetails?.user?.userId);
                                    setProfileMemberPayloadDetails({
                                        teamId: null,
                                        userId: selectedUserId,
                                        firstName: "",
                                        lastName: "",
                                        memberTitle: "",
                                        memberEmail: "",
                                        memberPhone: "",
                                        image: 0,
                                        isDefault: false,
                                        description: ""
                                    })
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }} sx={{ margin: "5px 0px 0px", maxHeight: "calc(100vh - 345px)", height: profileTeamDetails?.length ? 'fit-content' : "160px" }}>
                            <DataGrid
                                rows={profileTeamDetails}
                                columns={columns}
                                density='standard'
                                getRowId={(row) => row.teamId}
                                className={`${globalStyles.globalDatagridStyles}  ${styles.userTableStyles}`}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                rowHeight={50}
                                columnHeaderHeight={50}
                                rowCount={profileTeamDetails?.length}
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 10, page: 0 }
                                    }
                                }}
                                slots={{
                                    noRowsOverlay: NoDataOverlay
                                }}
                                pageSizeOptions={[5, 10, 25, { value: 100, label: '100' }]}
                                getRowClassName={(params) => {
                                    const isDefaultRow = params.row.isDefault;
                                    if (isDefaultRow) {
                                        return isProfileAdmin ? styles.clickableRow : styles.nonClickableRow;
                                    }
                                    return styles.clickableRow;
                                }}

                                onRowClick={(params) => {
                                    const rowData = params.row;
                                    // Prevent non-admins from clicking on default rows
                                    if (!isProfileAdmin && rowData.isDefault) return;

                                    // Fallback to selected dropdown user if assignedToUserId is null
                                    const resolvedUserId = rowData?.assignedToUserId ?? selectedUserId ?? null;

                                    setSelectedUserId(resolvedUserId);
                                    setProfileMemberPayloadDetails({
                                        assignedToUserId: rowData?.assignedToUserId ?? resolvedUserId,
                                        teamId: rowData?.teamId ?? null,
                                        userId: resolvedUserId,
                                        // userId: rowData?.userId ?? null,
                                        firstName: rowData?.firstName ?? "",
                                        lastName: rowData.lastName ?? "",
                                        memberTitle: rowData.memberTitle ?? "",
                                        memberEmail: rowData.memberEmail ?? "",
                                        memberPhone: rowData.memberPhone ?? "",
                                        description: rowData.description ?? "",
                                        image: rowData.image ?? 0,
                                        isDefault: rowData.isDefault ?? false
                                    });
                                    setFlagOpenNewMemberDialog(true);
                                }}
                                sx={{
                                    '& .MuiToolbar-root': { minHeight: '45px !important' },
                                    '& .non-clickable-row': { cursor: 'default !important' },
                                    '& .MuiDataGrid-row:hover': { backgroundColor: '#939ba354' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProfileAcrylicTeam